(function () {
  function reveal() {
    document.querySelectorAll('span.js-email-protect').forEach((el) => {
      const u = el.dataset.u;
      const d = el.dataset.d;
      if (u && d) el.textContent = u + '@' + d;
    });

    document.querySelectorAll('a.js-email-protect').forEach((el) => {
      const u = el.dataset.u;
      const d = el.dataset.d;
      if (!u || !d) return;
      el.setAttribute('href', 'mailto:' + u + '@' + d);
      if (!el.textContent.trim()) el.textContent = u + '@' + d;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();